import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { Observable } from 'rxjs';
import {
  Alert,
  AlertConfig,
  AlertAction,
  IAlertContainer,
} from '@surface-elements/shared/alert-system/domain';
import { AlertFacade } from '@surface-elements/shared/alert-system/data-access';
import { alertAnimations } from '../animations/alert.animations';
import { CommonModule } from '@angular/common';
import { AlertItemComponent } from '../alert-item/alert-item.component';

@Component({
  selector: 'app-alert-container',
  templateUrl: './alert-container.component.html',
  styleUrls: ['./alert-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [alertAnimations],
  imports: [CommonModule, AlertItemComponent],
})
export class AlertContainerComponent implements IAlertContainer, OnInit {
  private alertFacade = inject(AlertFacade);

  alerts$: Observable<Alert[]>;
  config$: Observable<AlertConfig>;
  maxVisible = 5;

  constructor() {
    this.alerts$ = this.alertFacade.allAlerts$;
    this.config$ = this.alertFacade.config$;
  }

  ngOnInit(): void {
    this.alertFacade.loadPersistedAlerts();
    this.config$.subscribe(config => {
      this.maxVisible = config.maxAlerts;
    });
  }

  trackById(index: number, alert: Alert): string {
    return alert.id;
  }

  onAlertDismiss(id: string): void {
    this.alertFacade.removeAlert(id);
  }

  onDismiss(id: string): void {
    this.onAlertDismiss(id);
  }

  onAction(action: AlertAction): void {
    if (action.callback && typeof action.callback === 'function') {
      action.callback();
    }
  }
}
